import isBlankTemplate from '../verifiers/is-blank-template';

const splitTemplates = (templates) => ({
  commonTemplates: templates.filter((template) => !isBlankTemplate(template)),
  blankTemplate: templates.find((template) => isBlankTemplate(template)),
});

export default splitTemplates;
